"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NullReference = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _reactivity = require("@vue/reactivity");
let varIndex = 1;
class NullReference {
  constructor() {
    (0, _defineProperty2.default)(this, "ref", void 0);
    (0, _defineProperty2.default)(this, "index", void 0);
    this.index = varIndex++;
  }
  get valueType() {
    return "null";
  }
  get variableType() {
    return "null";
  }
  value() {
    if (!this.ref) {
      this.ref = (0, _reactivity.ref)();
      this.ref.value = null;
    }
    return {
      type: "null",
      value: this.ref.value
    };
  }
  stop() {
    this.ref = undefined;
  }
  trigger() {
    if (this.ref) {
      (0, _reactivity.triggerRef)(this.ref);
    }
  }
}
exports.NullReference = NullReference;
//# sourceMappingURL=NullReference.js.map